import { useParams } from "react-router-dom";
import { useLocales, useUser } from "../../hooks";
import { useState } from "react";
import {
  isExists,
  locale,
  params,
  priorityOptions,
  workOrderStatusOptions,
  workOrderTypeOptions,
} from "../../utils";
import { useGetListQuery } from "../../features/api/Api";
import { Box, CircularProgress, Grid, Typography } from "@mui/material";
import { GridColDef } from "@mui/x-data-grid";
import {
  EnumField,
  FormFooter,
  List,
  ListEditButton,
  MuiDatagrid,
} from "../../components";
import { defaultToolbar } from "../../components/views/datagrid/MuiDatagrid";
import WorkOrderListFilter from "./WorkOrderListFilter";

export default function CustomerWorkOrder() {
  const { customerId } = useParams();
  const { user } = useUser();
  const { translate } = useLocales();
  const tableName = translate("resources.customers.workorders");

  const [workorderParams, setWorkorderParams] = useState({
    resource: `fixity/workorder/workorder`,
    params: {
      ...params,
      filter: {
        // creatorId: user?.customerId,
        customerIds: customerId,
        isDeleted: false,
      },
    },
  });

  const { data: workorder, isLoading } = useGetListQuery<any>(workorderParams);

  const categoryActions = (
    <>
      {/* <Link to="/basvurular/create">
        <IconButton
          className="btn btn-light "
          icon="icon-plus"
          label={translate("create_new")}
          styles={{ marginLeft: "15px" }}
        />
      </Link> */}
    </>
  );

  const columns: GridColDef[] = [
    {
      field: "workOrderNumber",
      headerName: translate("resources.customers.workorder.number"),
      flex: 1,
    },
    {
      field: "title",
      headerName: translate("resources.customers.workorder.title"),
      flex: 1,
    },
    {
      field: "description",
      headerName: translate("resources.customers.workorder.description"),
      flex: 1,
    },

    {
      field: "priorityId",
      headerName: translate("resources.customers.workorder.priority"),
      flex: 1,
      renderCell: ({ value }) => (
        <EnumField
          data={value}
          options={locale(priorityOptions, "resources.customers.workorder.")}
        />
      ),
    },
    {
      field: "typeId",
      headerName: translate("resources.customers.workorder.type"),
      flex: 1,
      renderCell: ({ value }) => (
        <EnumField
          data={value}
          options={locale(
            workOrderTypeOptions,
            "resources.customers.workorder."
          )}
        />
      ),
    },
    {
      field: "statusId",
      headerName: translate("resources.customers.workorder.status"),
      flex: 1,
      renderCell: ({ value }) => (
        <EnumField
          data={value}
          options={locale(
            workOrderStatusOptions,
            "resources.customers.workorder."
          )}
        />
      ),
    },

    {
      field: translate("actions.edit"),
      headerName: "",
      disableColumnMenu: true,
      disableReorder: true,
      filterable: false,
      hideSortIcons: true,
      sortable: false,
      align: "center",
      width: 50,
      renderCell: (params) => (
        <ListEditButton data={params} path="general" beforeDelete={true} />
      ),
    },
  ];

  return (
    <div>
      {isLoading ? (
        <Box textAlign="center">
          <CircularProgress />
          <Typography variant="h5">
            Veriler Yükleniyor. Lütfen Bekleyiniz...
          </Typography>
        </Box>
      ) : (
        <Grid>
          <List tableName={tableName} actions={categoryActions}>
            <MuiDatagrid
              loading={false}
              rows={isExists(workorder?.data) ? workorder.data : []}
              columns={columns}
              rowCount={workorder?.totalItemCount}
              pageSize={workorderParams.params.pagination.size}
              pageNumber={workorderParams.params.pagination.pageNumber}
              setPagination={setWorkorderParams}
              filters={<WorkOrderListFilter onSubmit={setWorkorderParams} />}
              hideToolbars={{ ...defaultToolbar, create: false }}
            />
          </List>
        </Grid>
      )}
      <FormFooter />
    </div>
  );
}
